import React from "react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import * as moment from "moment-timezone";

import Grid from '@material-ui/core/Grid';
import Button from '../../../../components/Button';

export const ExportToExcel = ({ apiData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const date = moment.tz('America/Lima').format('YYYY-MM-DD HH_mm_ss')
    console.log('view date: ', date)
    fileName = `Gruporomero-colaboradores-analytics-${date}`

    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <Grid item xs={6} sm="auto">
      <Button
        color="success"
        fullWidth
        onClick={(e) => exportToCSV(apiData, fileName)}
        square
      >
        Descargar
      </Button>
    </Grid>
  );
};
